module.exports = __webpack_public_path__ + "static/img/bg-match3.a1d8c9f9.png";